// extracted by mini-css-extract-plugin
export default {"app":"Home_app__BOjRt"};